import React from 'react'
import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import MessagesList from './components/MessagesList'

const MyMessages: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <MessagesList />
      <Footer />
    </>
  )
}

export default MyMessages
